import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ClockIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 23 23"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 23)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <circle cx="11.5" cy="11.5" r="10.75" />
      <path d="M11.5 11.5v-8" />
      <path d="m11.5 11.5 3-5" />
    </SVG>
  );
};
